import { useEffect } from 'react'
import { EditorialMedia } from './EditorialMedia'
import { SectionHeading } from './SectionHeading'
import { SmartLink } from './SmartLink'
import { usePreviewSelection } from './usePreviewSelection'
import { useLanguage } from '../i18n'

export function Consulting() {
  const { copy } = useLanguage()
  const consultingAreas = copy.consulting.areas
  const selection = usePreviewSelection()
  const activeArea = consultingAreas[selection.activeIndex]

  useEffect(() => {
    const preloadedImages: HTMLImageElement[] = []
    const preload = window.setTimeout(() => {
      consultingAreas.forEach((area) => {
        if (!area.media?.desktopSrc) return
        const image = new Image()
        image.src = area.media.desktopSrc
        preloadedImages.push(image)
      })
    }, 500)

    return () => {
      window.clearTimeout(preload)
      preloadedImages.length = 0
    }
  }, [consultingAreas])

  return (
    <section id="consultoria" className="section section--light consulting" aria-labelledby="consulting-title">
      <div className="container">
        <SectionHeading
          id="consulting-title"
          kicker={copy.consulting.kicker}
          title={copy.consulting.title}
          mobileTitle={copy.consulting.mobileTitle}
          introduction={copy.consulting.introduction}
          mobileIntroduction={copy.consulting.mobileIntroduction}
        />

        <div className="consulting-layout">
          <div ref={selection.scopeRef} className="selector-list" role="list" aria-label={copy.consulting.selectorLabel}>
            {consultingAreas.map((area, index) => (
              <button
                type="button"
                role="listitem"
                key={area.name}
                className={`selector-item ${selection.activeIndex === index ? 'selector-item--active' : ''}`}
                aria-pressed={selection.selectedIndex === index}
                onMouseEnter={() => selection.preview(index)}
                onFocus={() => selection.preview(index)}
                onClick={() => selection.commit(index)}
              >
                <span>{String(index + 1).padStart(2, '0')}</span>
                <strong>{area.name}</strong>
                <i aria-hidden="true">↗</i>
              </button>
            ))}
          </div>

          <article className="editorial-panel consulting-panel" aria-live="polite">
            <div className="editorial-panel__grid" aria-hidden="true" />
            <EditorialMedia
              label="Imagem da área de consultoria"
              alt=""
              index={selection.activeIndex}
              className="consulting-panel__media"
              {...activeArea.media}
            />
            <div className="consulting-panel__content">
              <div className="consulting-panel__heading">
                <span className="panel-label">{copy.consulting.panelLabel}</span>
                <h3>{activeArea.name}</h3>
              </div>
              <div className="consulting-panel__focus">
                <span>{copy.consulting.focusLabel}</span>
                <strong>{activeArea.focus}</strong>
              </div>
              <p>{activeArea.text}</p>
              {activeArea.see && (
                <SmartLink
                  className="consulting-panel__see"
                  href={activeArea.see.href}
                >
                  <span>{copy.consulting.seeLabel}</span>
                  <strong>{activeArea.see.label}</strong>
                  <i aria-hidden="true">↗</i>
                </SmartLink>
              )}
            </div>
          </article>
        </div>

        <a className="button button--dark section-cta" href="mailto:comercial@geniuslead.com.br">{copy.consulting.contact}</a>
      </div>
    </section>
  )
}
